import { render, staticRenderFns } from "./side-menu.vue?vue&type=template&id=69420780&scoped=true"
import script from "./side-menu.vue?vue&type=script&lang=js"
export * from "./side-menu.vue?vue&type=script&lang=js"
import style0 from "./side-menu.vue?vue&type=style&index=0&id=69420780&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69420780",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/LRL_LCDDMAC_eMSL_CFC/LRL_LCDDMAC_eMSL_CFC/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69420780')) {
      api.createRecord('69420780', component.options)
    } else {
      api.reload('69420780', component.options)
    }
    module.hot.accept("./side-menu.vue?vue&type=template&id=69420780&scoped=true", function () {
      api.rerender('69420780', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/side-menu.vue"
export default component.exports